import { useAuth } from '../providers/AuthProvider';

export const useApiClient = () => {
    const { apiClient } = useAuth();
    return apiClient;
};
